import {z} from "zod";
import {UiReferenceFieldBaseSchema} from "./UiReferenceField";

export const SMART_REFERENCE_SELECT_FIELD_COMPONENT_TYPE = 'SmartReferenceSelectField';

export const SmartReferenceSelectFieldSchema = UiReferenceFieldBaseSchema.extend({
    componentType: z.literal(SMART_REFERENCE_SELECT_FIELD_COMPONENT_TYPE),
});

export type SmartReferenceSelectField = z.infer<typeof SmartReferenceSelectFieldSchema>;